import React from "react";

import "./Policy.scss";

function Policy() {
    
    return(

        <div className="banzai_footer_info">
            <p className="cervoSm"> Grif Srl | P.IVA 01596200210 - <a href="mailto:info@nudolsbanzai.it">info@nudolsbanzai.it</a></p>            
            <div className="banzai_footer_info__policy">
                <a target="_blank" rel="noreferrer" href="https://www.iubenda.com/privacy-policy/48563156/cookie-policy" class="iubenda-nostyle iubenda-noiframe iubenda-embed iubenda-noiframe cervoSm uppercase" title="Cookie Policy ">Cookie Policy</a>
                <a target="_blank" rel="noreferrer" href="https://www.iubenda.com/privacy-policy/48563156" class="iubenda-nostyle iubenda-noiframe iubenda-embed iubenda-noiframe cervoSm uppercase" title="Privacy Policy ">Privacy Policy</a>
            </div>
        </div>

    )

}

export default Policy;